import { UserNotification } from './notification';
import { IPushMessageSettings } from './pushMessageSettings';

export * from './device';
export * from './invitations';
export * from './notification';
export * from './pushMessageSettings';
export * from './emailNotificationSettings';
export * from './waitlist';
export * from './types';
export * from './demerits';
export * from './payments';
export * from './onboarding';
export * from './bookings';

// dummy UserProfile
export class UserProfile {
  public notifications: UserNotification[];
  public pushMessageSettings: IPushMessageSettings;
}
